"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserDirectoryProvider = void 0;
const react_1 = __importStar(require("react"));
const emptyUserDirectory_1 = require("./emptyUserDirectory");
const UserDirectoryContext_1 = require("./UserDirectoryContext");
const OrganizationContext_1 = require("./OrganizationContext");
const UserDirectoryProvider = ({ children, }) => {
    const { selectedOrgUser } = (0, react_1.useContext)(OrganizationContext_1.OrganizationContext);
    // Derive from selectedOrgUser during render (not via an effect) so this context
    // can't lag OrganizationContext on org switch
    const userDirectory = selectedOrgUser === null || selectedOrgUser === void 0 ? void 0 : selectedOrgUser.userDirectory;
    const [version, bumpVersion] = (0, react_1.useReducer)((v) => v + 1, 0);
    (0, react_1.useEffect)(() => {
        if (!userDirectory)
            return;
        return userDirectory.registerChangeListener(() => bumpVersion());
    }, [userDirectory]);
    const users = (0, react_1.useMemo)(() => { var _a; return (_a = userDirectory === null || userDirectory === void 0 ? void 0 : userDirectory.getUserDirectory()) !== null && _a !== void 0 ? _a : []; }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [userDirectory, version]);
    // Fall back rather than pass undefined through the cast: resetData clears
    // selectedOrgUser on logout while the authenticated screens are still
    // mounted, and consumers read userDirectory unguarded because the context
    // types it as always present (MOBILE-APP-B4, MOBILE-APP-CQ).
    const value = (0, react_1.useMemo)(() => ({ userDirectory: userDirectory !== null && userDirectory !== void 0 ? userDirectory : emptyUserDirectory_1.emptyUserDirectory, users }), [userDirectory, users]);
    return (react_1.default.createElement(UserDirectoryContext_1.UserDirectoryContext.Provider, { value: value }, children));
};
exports.UserDirectoryProvider = UserDirectoryProvider;
